import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import '../../../assets/AdminCss/cricket.css';
import { useLocation } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

import axios from "axios";
import { base_url } from "../../../context/Authcontext";

import CricketScoreboard from "../../CricketScoreboard";
import BetModal from "./BetModal";


const HomeCricket = () => {
    //   const { marketId2 } = useParams();
    // console.log("marketnmndm", marketId2);
    const [isSidebarOpen, setIsSidebarOpen] = useState(
        !(window.innerWidth < 768)
    );
    // console.log( "trgyjbrh3kgk" ,marketId2); // e.g., "34359959"
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    const [isSidebar, setSidebar] = useState(false);
    const location = useLocation();
    const [back1, setBack1] = useState([]);
    const [lay1, setLay1] = useState([]);
    const [back2, setBack2] = useState([]);
    const [lay2, setLay2] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    const [newactive, setNewActive] = useState(0);
    const [isExpanded, setIsExpanded] = useState(1);
    const [isExpanded1, setIsExpanded1] = useState(1);

    const [isExpanded3, setIsExpanded3] = useState(1);
    const [isExpanded4, setIsExpanded4] = useState(1);
    const [isExpanded5, setIsExpanded5] = useState(1);
    const [isExpanded6, setIsExpanded6] = useState(1);
    const [fancyData, setFancyData] = useState();
    const [fancyName, setFancyName] = useState('');

    const [selectedPrice, setSelectedPrice] = useState();
    const [money, setMoney] = useState(0);

    const [marketId, setMarketId] = useState(() => {
        return sessionStorage.getItem("marketId") || "";
    });

    const [runner1, setRunner1] = useState(() => {
        return sessionStorage.getItem("runner1") || "";
    });

    const [runner2, setRunner2] = useState(() => {
        return sessionStorage.getItem("runner2") || "";
    });

    const competiton = sessionStorage.getItem("competitionname");
    const event = sessionStorage.getItem("eventname");
    const selectionid1 = sessionStorage.getItem("selectionid1");
    const selectionid2 = sessionStorage.getItem("selectionid2");
    const selectionid3 = sessionStorage.getItem("selectionid3") || "";
    const runner3 = sessionStorage.getItem("runner3") || "";

    const eventId = sessionStorage.getItem("eventid");

    const [fancy, setFancy] = useState([]);
    const [back3, setBack3] = useState([]);
    const [lay3, setLay3] = useState([]);

    const [startTime, setStartTime] = useState();
    const [book1, setBook1] = useState([]);
    const [book2, setBook2] = useState([]);
    const [channel, setChannel] = useState();
    const [betData, setBetData] = useState([]);
    const [fancyBetData, setFancyBetData] = useState([]);
    const [toss1, setToss1] = useState();
    const [toss2, setToss2] = useState();
    const [play, setPlay] = useState(false);
    const [mini1, setMini1] = useState([]);
    const [mini2, setMini2] = useState([]);
    const [oddEven, setOddEven] = useState([]);
    const [session, setSession] = useState([]);
    const [wpMarket, setWPMarket] = useState([]);
    const [unmatch, setUnmatch] = useState([]);
    const [oddb1, setOddb1] = useState('');
    const [oddb2, setOddb2] = useState('');
    const [oddm1, setOddm1] = useState('');
    const [oddm2, setOddm2] = useState('');

    const [matchLiabilities, setMatchLiabilities] = useState();

    const betDataa = async () => {
        const marketId = sessionStorage.getItem("marketId");
        // console.log("marketid ", marketId)
        try {
            const response = await axios.post(
                base_url + "/admin/webapi/betData",
                { marketId },
                {
                    withCredentials: true,
                    headers: {
                        "content-type": "application/json",
                    },
                }
            );

            // console.log("databet", response);

            if (response?.data.success) {
                const sportsBets = response?.data.sportsBets;
                const fancyBets = response?.data.fancyBets;
                const unmach = response?.data.unmatch;
                // console.log('ddd',data);
                setBetData(sportsBets);
                setFancyBetData(fancyBets);
                setUnmatch(unmach);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 991) {
                setSidebar(true);
            } else {
                setSidebar(false);
            }
        };

        if (location.state?.marketId) {
            sessionStorage.setItem("marketId", location.state.marketId);
            setRunner1(location.state.marketId);
        }

        if (location.state?.runner1) {
            sessionStorage.setItem("runner1", location.state.runner1);
            setRunner2(location.state.runner1);
        }

        if (location.state?.runner2) {
            sessionStorage.setItem("runner2", location.state.runner2);
            setMarketId(location.state.runner2);
        }
        // Add event listener for resize
        window.addEventListener("resize", handleResize);
        handleResize();

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
            // sessionStorage.clear();
        };
    }, [location.state, money, selectedPrice]);

    // console.log(channel)

    useEffect(() => {
        window.scrollTo(0, 0);

        // const fancyData = async () => {
        //     try {
        //         const response = await axios.get(base_url + "/api/webapi/getFancy",
        //             {
        //                 headers: {
        //                     'content-type': 'application/json',
        //                 }
        //             }
        //         );

        //         if (response?.data?.data && Array.isArray(response?.data.data)) {
        //             const fetchedData = response.data.data;

        //             // console.log(fetchedData,"fetchdata")

        //             const competitionId = sessionStorage.getItem("eventid");
        //             const matchedData = fetchedData.filter(
        //                 (item) => item.eventId === competitionId
        //             );

        //             const oddData = matchedData.filter((item) => {
        //                 return (
        //                     (item.marketName.includes("Odd") ||
        //                         item.marketName.includes("even")) &&
        //                     !item.marketName.includes("Wicket") &&
        //                     !item.marketName.includes("Fall") &&
        //                     !item.marketName.includes("Boundaries")
        //                 );
        //             });

        //             // console.log(oddData, "nejjcncj");
        //             const sess = matchedData.filter((item) => {
        //                 return (
        //                     (item.marketName.includes("Over") ||
        //                         item.marketName.includes("Match")) &&
        //                     !item.marketName.includes("Lambi") &&
        //                     !item.marketName.includes("Fall") &&
        //                     !item.marketName.includes("Boundaries")
        //                 );
        //             });
        //             const wp = matchedData.filter(
        //                 (item) =>
        //                     item.marketName.includes("Fall") ||
        //                     item.marketName.includes("fall") ||
        //                     item.marketName.includes("Boundaries") ||
        //                     item.marketName.includes("Wicket")
        //             );
        //             const mtch = matchedData.filter((item) => {
        //                 return (
        //                     !item.marketName.includes("Odd") &&
        //                     !item.marketName.includes("Even") &&
        //                     !item.marketName.includes("Over") &&
        //                     !item.marketName.includes("Match") &&
        //                     !item.marketName.includes("Fall") &&
        //                     !item.marketName.includes("Wicket") &&
        //                     !item.marketName.includes("Boundaries")
        //                 );
        //             });

        //             // console.log(sess,"cdvvver")

        //             setFancyData(matchedData);
        //             setSession(sess);
        //             setOddEven(oddData);
        //             setWPMarket(wp);
        //             setFancy(mtch);
        //         } else {
        //             setFancy([]);
        //         }
        //     } catch (err) {
        //         console.error("Error fetching fancy data:", err);
        //         setFancy([]);
        //     }
        // };

        const bookMakerData = async () => {
            try {
                const competitionid = sessionStorage.getItem("eventid");
                const response = await axios.get(base_url + "/api/webapi/getBookMaker", { params: { eventId: competitionid } });
                // console.log("Full API Response:", response.data);

                if (response?.data?.data && Array.isArray(response.data.data)) {
                    const fetchedData = response?.data.data;
                    // console.log('fetch mini', fetchedData);

                    const competitionId = sessionStorage.getItem("eventid");

                    const tossMatchedData = fetchedData.filter(
                        (item) =>
                            item.mname === "To Win The Toss"
                    );

                    const bookmakerData = fetchedData.filter(
                        (item) =>
                            item.mname === "Bookmaker"
                    );

                    const miniBookmaker = fetchedData.filter(
                        (item) =>
                            item.mname === "Mini_Bookmaker"
                    );

                    const sessionData = fetchedData.filter(
                        (item) =>
                            item.mname === "Normal"
                    );

                    const wpData = fetchedData.filter(
                        (item) =>
                            item.mname === "meter"
                    );

                    const xtraData = fetchedData.filter(
                        (item) =>
                            item.mname === "fancy1"
                    );

                    const oddEvenData = fetchedData.filter(
                        (item) =>
                            item.mname === "oddeven"
                    );

                    const mini2 = miniBookmaker[0]?.section[0];
                    const mini1 = miniBookmaker[0]?.section[1];

                    const toss1 = tossMatchedData[0]?.section[0];   
                    const toss2 = tossMatchedData[0]?.section[1];

                    const bookmaker1 = bookmakerData[0]?.section[0];
                    const bookmaker2 = bookmakerData[0]?.section[1];


                    // Session
                    const sections = sessionData?.[0]?.section || [];
                    const formattedSessions = sections.map((sec) => ({
                        nat: sec?.nat,
                        status: sec?.gstatus === "" ? "OPEN" : sec?.gstatus,
                        odds1: sec?.odds?.[0] || {},
                        odds2: sec?.odds?.[1] || {},
                    }));

                    // WP Market
                    const wpMarket = wpData?.[0]?.section || [];
                    const formattedWP = wpMarket.map((sec) => ({
                        nat: sec?.nat,
                        status: sec?.gstatus === "" ? "OPEN" : sec?.gstatus,
                        odds1: sec?.odds?.[0] || {},
                        odds2: sec?.odds?.[1] || {},
                    }));

                    // xtra
                    const xtra = xtraData?.[0]?.section || [];
                    const formattedxtra = xtra.map((sec) => ({
                        nat: sec?.nat,
                        status: sec?.gstatus === "" ? "OPEN" : sec?.gstatus,
                        odds1: sec?.odds?.[0] || {},
                        odds2: sec?.odds?.[1] || {},
                    }));

                    // oddEvenData
                    const oddeven = oddEvenData?.[0]?.section || [];
                    const formattedoddeven = oddeven.map((sec) => ({
                        nat: sec?.nat,
                        status: sec?.gstatus === "" ? "OPEN" : sec?.gstatus,
                        odds1: sec?.odds?.[0] || {},
                        odds2: sec?.odds?.[1] || {},
                    }));


                    const oddsb1 = bookmaker1?.odds?.map(item => item) || [];
                    const oddsb2 = bookmaker2?.odds?.map(item => item) || [];
                    setOddb1(oddsb1);
                    setOddb2(oddsb2);
                    const oddsm1 = mini2?.odds?.map(item => item) || [];
                    const oddsm2 = mini1?.odds?.map(item => item) || [];
                    setOddm1(oddsm1);
                    setOddm2(oddsm2);


                    setBook1(bookmaker2);
                    setBook2(bookmaker1);
                    setToss1(toss1);
                    setToss2(toss2);
                    setMini1(mini1);
                    setMini2(mini2);

                    setFancyData(fetchedData);
                    setSession(formattedSessions);
                    setOddEven(formattedoddeven);
                    setWPMarket(formattedWP);
                    setFancy(formattedxtra);
                } else {
                    setFancy([]);
                }
            } catch (err) {
                console.error("Error fetching fancy data:", err);
                setFancy([]);
            }
        };

        const backLay = async () => {
            try {
                const response = await axios.get(
                    base_url + `/api/webapi/market/${marketId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                const status1 = response?.data.result[0].status;
                const status2 = response?.data.result[1].status;

                if (status1 === "OPEN" || status1 === "ACTIVE") {
                    const backk2 = response?.data.result[0].ex?.availableToBack;
                    const layy2 = response?.data.result[1].ex?.availableToLay;
                }

                if (response?.data.result.length === 3) {
                    const status3 = response?.data.result[2]?.status;

                    if (status1 === "OPEN" || status1 === "ACTIVE") {
                        const backk3 = response?.data.result[0].ex?.availableToBack;
                        const layy3 = response?.data.result[1].ex?.availableToLay;

                        setBack3(backk3);
                        setLay3(layy3);
                    }
                }

                if (status1 === "OPEN" || status1 === "ACTIVE") {
                    const backk1 = response?.data.result[0].ex?.availableToBack;
                    const layy1 = response?.data.result[1].ex?.availableToLay;

                    setBack1(backk1);
                    setLay1(layy1);
                }

                if (status1 === "OPEN" || status1 === "ACTIVE") {
                    const backk2 = response?.data.result[1]?.ex?.availableToBack;
                    const layy2 = response?.data.result[1]?.ex?.availableToLay;

                    setBack2(backk2);
                    setLay2(layy2);
                }

                // console.log("layback", lay1, back1, lay2, back2)

            } catch (err) {
                console.log("Error fetching in odds data", err);
            }
        };

        const calculateAdminPnLByMarket = (userBets, team1, team2) => {
            const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
            const result = {};

            marketTypes.forEach((market) => {
                const marketBets = userBets.filter(
                    (b) => b.type.toLowerCase() === market
                );

                const runnerPnl = {};
                const runners = new Set(marketBets.map((b) => b.runnerName));
                runners.add(team1);
                runners.add(team2);
                const runner3 = sessionStorage.getItem("runner3");
                if (runner3 && runner3.toLowerCase() === "the draw") {
                    runners.add("The Draw");
                }

                for (const runner of runners) {
                    runnerPnl[runner] = 0;
                }

                // Reverse user's PnL to get admin's profit/loss
                marketBets.forEach(({ runnerName, side, betprice, betAmount }) => {
                    const odds = parseFloat(betprice);
                    const stake = parseFloat(betAmount);

                    for (const currentRunner of runners) {
                        if (currentRunner === runnerName) {
                            if (side === "Back") {
                                runnerPnl[currentRunner] -= (odds - 1) * stake;
                            } else if (side === "Lay") {
                                runnerPnl[currentRunner] += (odds - 1) * stake;
                            }
                        } else {
                            if (side === "Back") {
                                runnerPnl[currentRunner] += stake;
                            } else if (side === "Lay") {
                                runnerPnl[currentRunner] -= stake;
                            }
                        }
                    }
                });

                // Round to 2 decimal places
                Object.keys(runnerPnl).forEach((runner) => {
                    runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
                });

                const liability = Object.values(runnerPnl).length
                    ? Math.min(...Object.values(runnerPnl))
                    : '';

                result[market] = {
                    pnl: runnerPnl,
                    liability: parseFloat(liability.toFixed(2)),
                };
            });

            return result;
        };

        const getMatchLiablities = async () => {
            try {
                const response = await axios.get(
                    `${base_url}/api/webapi/getAdminMatchLiablity/${eventId}`,
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: true,
                    }
                );

                const bets = response.data;
                const { team1, team2 } = bets[0] || {};

                const adminResult = calculateAdminPnLByMarket(bets, team1, team2);

                setMatchLiabilities(adminResult); // or return this if using backend
            } catch (err) {
                console.error("Error fetching admin P/L:", err);
            }
        };

        function formatDate(isoString) {
            const date = new Date(isoString);
            return date.toLocaleString("en-US", {
                year: "2-digit",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            });
        }

        const sessiontime = sessionStorage.getItem("time");
        const time = formatDate(sessiontime);
        // console.log('time',time);
        setStartTime(time);

        const updateData = async () => {
            betDataa();
            // await fancyData();
            await bookMakerData();
            await backLay();
            await getMatchLiablities();
        };

        //     setInterval(() => {
        //   betDataa();
        //   fancyData();
        // }, 1000);

        const intervalId = setInterval(updateData, 1000);

        // Cleanup function to clear interval on component unmount
        return () => clearInterval(intervalId);
    }, []);


    const calculateFancyPositions = (bets, targetRate) => {
        let position = 0;

        bets.forEach(bet => {
            const betRate = parseFloat(bet.rate);
            const betAmount = parseFloat(bet.betAmount);

            if (bet.side === 'no') { // lay bet
                if (targetRate >= betRate) {
                    // Lay bet loses - we pay out the liability (stake amount)
                    position -= betAmount;
                } else {
                    // Lay bet wins - we keep the stake
                    position += betAmount;
                }
            } else if (bet.side === 'yes') { // back bet
                if (targetRate >= betRate) {
                    // Back bet wins - we get profit (stake amount for fancy bets)
                    position += betAmount;
                } else {
                    // Back bet loses - we lose the stake
                    position -= betAmount;
                }
            }
        });

        return position;
    };


    const calculateOverallPosition = (fancyName, fancyBetData) => {
        const betsForFancy = fancyBetData.filter(bet => bet.runnerName === fancyName);
        if (betsForFancy.length === 0) return { profit: 0, loss: 0 };

        // Get the current rate for this fancy (assuming it's available)
        const currentRate = betsForFancy[0]?.rate || 0;

        // Calculate best case and worst case scenarios
        let bestCase = -Infinity;
        let worstCase = Infinity;

        // Check positions for a range of possible outcomes
        for (let rate = parseFloat(currentRate) - 10; rate <= parseFloat(currentRate) + 10; rate++) {
            const position = calculateFancyPositions(betsForFancy, rate);
            bestCase = Math.max(bestCase, position);
            worstCase = Math.min(worstCase, position);
        }

        return {
            profit: bestCase > 0 ? bestCase : 0,
            loss: worstCase < 0 ? worstCase : 0
        };
    };

    // Generate modal table data with correct position calculations
    const generateModalTableData = (fancyName, fancyBetData) => {
        const betsForFancy = fancyBetData.filter(bet => bet.runnerName === fancyName);
        if (betsForFancy.length === 0) return [];

        // Get the range of rates from bets
        const rates = betsForFancy.map(bet => parseFloat(bet.rate));
        const minRate = Math.min(...rates);
        const maxRate = Math.max(...rates);

        // Generate table data for rate-1, rate, rate+1 for each bet
        const tableData = [];
        const processedRates = new Set();

        rates.forEach(rate => {
            [rate - 1, rate, rate + 1].forEach(targetRate => {
                if (!processedRates.has(targetRate)) {
                    processedRates.add(targetRate);
                    const position = calculateFancyPositions(betsForFancy, targetRate);
                    const adminPosition = -position;
                    tableData.push({
                        rate: targetRate,
                        position: adminPosition
                    });
                }
            });
        });

        // Sort by rate
        return tableData.sort((a, b) => a.rate - b.rate);
    };

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);

            // On desktop, sidebar should always be "open"
            if (!mobile) {
                setIsSidebarOpen(true);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // console.log('matchess',matchLiabilities);

    // console.log("fancy bet data is devanshs sijski", fancyBetData)

    return (
        <>
            <div className="wrapper">
             
                {/* Content Wrapper - Use conditional class and margin */}
                <div
                    className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
                        }`}
                    style={{
                        marginLeft: !isMobile && isSidebarOpen ? "" : "0",
                        transition: "margin-left 0.3s ease",
                    }}
                >
                    <div _ngcontent-jrx-c95="" className="head-containerr">
                        <div _ngcontent-jrx-c95="" className="body-container">
                            <div className=" d-flex flex-column flex-lg-row justify-content-between mainn w-100 p-2">
                                <div className="match-content">
                                    <div className="d-flex gap-5 align-items-center">
                                        {/* <span>Time Remaining: </span> */}
                                    </div>

                                    <CricketScoreboard />

                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className="text-dark fw-bold fs-5">{runner1}</span>{" "}
                                            :{" "}
                                            <span
                                                className={`${parseFloat(
                                                    matchLiabilities?.odds?.pnl?.[runner1] || 0
                                                ) +
                                                    parseFloat(
                                                        matchLiabilities?.bookmaker?.pnl?.[runner1] || 0
                                                    ) <
                                                    0
                                                    ? "text-red"
                                                    : "text-green"
                                                    }`}
                                            >
                                                {parseFloat(
                                                    matchLiabilities?.odds?.pnl?.[runner1] || 0
                                                ) +
                                                    parseFloat(
                                                        matchLiabilities?.bookmaker?.pnl?.[runner1] || 0
                                                    )}
                                            </span>
                                        </div>

                                        <div>
                                            <span className="text-dark fw-bold fs-5">{runner2}</span>{" "}
                                            :{" "}
                                            <span
                                                className={`${parseFloat(
                                                    matchLiabilities?.odds?.pnl?.[runner2] || 0
                                                ) +
                                                    parseFloat(
                                                        matchLiabilities?.bookmaker?.pnl?.[runner2] || 0
                                                    ) <
                                                    0
                                                    ? "text-red"
                                                    : "text-green"
                                                    }`}
                                            >
                                                {parseFloat(
                                                    matchLiabilities?.odds?.pnl?.[runner2] || 0
                                                ) +
                                                    parseFloat(
                                                        matchLiabilities?.bookmaker?.pnl?.[runner2] || 0
                                                    )}
                                            </span>
                                        </div>

                                        {back3.length > 0 && (
                                            <div>
                                                <span className="text-dark fw-bold fs-5">
                                                    {runner3}
                                                </span>{" "}
                                                :{" "}
                                                <span
                                                    className={`${matchLiabilities?.odds?.pnl?.[runner3] < 0
                                                        ? "text-red"
                                                        : "text-green"
                                                        }`}
                                                >
                                                    {matchLiabilities?.odds?.pnl?.[runner3]}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    {/* <p
                        className="breadcrumb mt-3"
                        style={{ fontFamily: "sans-serif", color: "grey" }}
                      >
                        Home &gt; Cricket &gt; {competiton} &gt;
                        {event} &gt; Match Odds
                      </p> */}
                                    {/* <span className="text-info fs-5 inline">Start Time: &nbsp;{startTime}</span> */}

                                    <div className="match-section">
                                        <div className="match-header d-flex align-items-end gap-2 ">
                                            <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-baseline">
                                                <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                                                    Match Odds
                                                </p>
                                                {/* <p className="d-flex gap-1 fszz">
                              <span>
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p> */}
                                            </div>

                                            <BetModal betData={betData} type="odds" />

                                            <div
                                                className="d-flex align-items-end gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                                                style={{ height: "5rem" }}
                                            >
                                                <p className="text-info fs-5">Back</p>
                                                <p className="text-pink fs-5">Lay</p>
                                            </div>
                                        </div>

                                        <div className="betting-options d-flex flex-column  gap-2">
                                            <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-center border-2 bg-dark p-2">
                                                <h5
                                                    className="fs-4 text-wrap run d-flex flex-column gap-1"
                                                    id={selectionid1}
                                                >
                                                    {runner1}

                                                    <span
                                                        className={`${matchLiabilities?.odds?.pnl?.[runner1] < 0
                                                            ? "text-red"
                                                            : "text-green"
                                                            }`}
                                                    >
                                                        {matchLiabilities?.odds?.pnl?.[runner1]}
                                                    </span>
                                                </h5>

                                                <div className="d-flex gap-2">
                                                    {back1?.map((bc, index) => (
                                                        <div
                                                            className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index < back1?.length - 1
                                                                ? "bg-secondary dnone"
                                                                : "bg-info"
                                                                }`}
                                                            style={{ width: "4rem" }}
                                                        >
                                                            {bc?.price}
                                                        </div>
                                                    ))}

                                                    {lay1?.map((bc, index) => (
                                                        <div
                                                            className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                                                }`}
                                                            style={{
                                                                width: "4rem",
                                                                backgroundColor: "#E83E8C",
                                                            }}
                                                        >
                                                            {bc?.price}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                                <h5
                                                    className="fs-4 text-wrap run d-flex flex-column gap-1"
                                                    id={selectionid2}
                                                >
                                                    {runner2}

                                                    <span
                                                        className={`${matchLiabilities?.odds?.pnl?.[runner2] < 0
                                                            ? "text-red"
                                                            : "text-green"
                                                            }`}
                                                    >
                                                        {matchLiabilities?.odds?.pnl?.[runner2]}
                                                    </span>
                                                </h5>

                                                <div className="d-flex  gap-2">
                                                    {back2
                                                        .slice()
                                                        .reverse()
                                                        .map((bc, index) => (
                                                            <div
                                                                className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index < back2.length - 1
                                                                    ? "bg-secondary dnone"
                                                                    : "bg-info"
                                                                    }`}
                                                                style={{ width: "4rem" }}
                                                            >
                                                                {bc.price}
                                                            </div>
                                                        ))}

                                                    {lay2.map((bc, index) => (
                                                        <div
                                                            className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                                                }`}
                                                            style={{
                                                                width: "4rem",
                                                                backgroundColor: "#E83E8C",
                                                            }}
                                                        >
                                                            {bc.price}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {back3.length > 0 && (
                                                <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                                    <h5
                                                        className="fs-4 text-wrap run d-flex flex-column gap-1"
                                                        id={selectionid2}
                                                    >
                                                        The Draw
                                                        <span
                                                            className={`${matchLiabilities?.odds?.pnl?.["The Draw"] < 0
                                                                ? "text-red"
                                                                : "text-green"
                                                                }`}
                                                        >
                                                            {matchLiabilities?.odds?.pnl?.["The Draw"]}
                                                        </span>
                                                    </h5>

                                                    <div className="d-flex  gap-2">
                                                        {back3
                                                            .slice()
                                                            .reverse()
                                                            .map((bc, index) => (
                                                                <div
                                                                    className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index < back2.length - 1
                                                                        ? "bg-secondary dnone"
                                                                        : "bg-info"
                                                                        }`}
                                                                    style={{ width: "4rem" }}
                                                                >
                                                                    {bc.price}
                                                                </div>
                                                            ))}

                                                        {lay3.map((bc, index) => (
                                                            <div
                                                                className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index === 0
                                                                    ? "bg-pink1"
                                                                    : "bg-secondary dnone"
                                                                    }`}
                                                                style={{
                                                                    width: "4rem",
                                                                    backgroundColor: "#E83E8C",
                                                                }}
                                                            >
                                                                {bc.price}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* bookmaker */}
                                        <div className="d-flex align-items-start gap-2 mt-4">
                                            <div className="d-flex flex-lg-row flex-column flex-md-row align-items-baseline">
                                                <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                                                    BookMaker
                                                </p>
                                                {/* <p className="d-flex gap-1 fszz">
                              <span>
                                Min:{minBookmaker} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxBookmaker}
                            </p> */}
                                            </div>

                                            <BetModal betData={betData} type="book maker" />
                                            {/* <p
                            className="btn btn-success rounded-pill text-black"
                            style={{ marginTop: "-6px" }}
                          >
                          <i className="bi bi-book"></i>
                          </p> */}

                                            {/* Toggle Button */}
                                            <button
                                                className="btn ms-auto me-4  white"
                                                onClick={() => setIsExpanded(isExpanded === 1 ? 0 : 1)}
                                                style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                            >
                                                {isExpanded === 1 ? "−" : "+"}
                                            </button>
                                        </div>

                                        {/* Wrap the betting options in a conditional render based on isExpanded state */}
                                        {isExpanded === 1 && (
                                            <div className="betting-options d-flex flex-column  gap-2">
                                                <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                                    <h5 className="fs-3 text-wrap run d-flex flex-column gap-1">
                                                        {runner1}
                                                        <span
                                                            className={`${matchLiabilities?.bookmaker?.[runner1]?.net < 0
                                                                ? "text-red"
                                                                : "text-green"
                                                                }`}
                                                        >
                                                            {matchLiabilities?.bookmaker?.[runner1]?.net}
                                                        </span>
                                                    </h5>

                                                    {book2?.gstatus === "ACTIVE" ? (
                                                        <div className="d-flex gap-2">
                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>
                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>

                                                            <div
                                                                className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                                                style={{ width: "4rem" }}
                                                            >
                                                                {oddb1[2]?.odds}
                                                            </div>

                                                            <div
                                                                className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                                                style={{
                                                                    width: "4rem",
                                                                    backgroundColor: "#E83E8C",
                                                                }}
                                                            >
                                                                {oddb1[3]?.odds}
                                                            </div>

                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>
                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>
                                                        </div>
                                                    ) : (
                                                        <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                                            {book2?.gstatus}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                                    <h5 className="fs-4 text-wrap run d-flex flex-column gap-1">
                                                        {runner2}
                                                        <span
                                                            className={`${matchLiabilities?.bookmaker?.[runner2]?.net < 0
                                                                ? "text-red"
                                                                : "text-green"
                                                                }`}
                                                        >
                                                            {matchLiabilities?.bookmaker?.[runner2]?.net}
                                                        </span>
                                                    </h5>

                                                    {book1?.gstatus === "ACTIVE" ? (
                                                        <div className="d-flex gap-2">
                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>
                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>

                                                            <div
                                                                className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                                                style={{ width: "4rem" }}
                                                            >
                                                                {oddb2[2]?.odds}
                                                            </div>

                                                            <div
                                                                className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                                                style={{
                                                                    width: "4rem",
                                                                    backgroundColor: "#E83E8C",
                                                                }}
                                                            >
                                                                {oddb2[3]?.odds}
                                                            </div>

                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>
                                                            <div
                                                                className="bg-secondary rounded p-2 dnone"
                                                                style={{ width: "4rem" }}
                                                            ></div>
                                                        </div>
                                                    ) : (
                                                        <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                                            {book1?.gstatus}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/* mini bookmaker data */}
                                        {(mini1?.status === "ACTIVE" ||
                                            mini2?.status !== "ACTIVE" ||
                                            mini1?.status === "SUSPENDED" ||
                                            mini2?.status !== "SUSPENDED") && (
                                                <>
                                                    <div className="d-flex align-items-start gap-2 mt-4">
                                                        <div className="d-flex flex-lg-row flex-column flex-md-row align-items-baseline">
                                                            <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                                                                Mini BookMaker
                                                            </p>
                                                            {/* <p className="d-flex gap-1 fszz">
                                  <span>
                                    Min:{minMiniBook} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxMiniBook}
                                </p> */}
                                                        </div>
                                                        <BetModal betData={betData} />

                                                        {/* <p
                                className="btn btn-success rounded-pill text-black"
                                style={{ marginTop: "-6px" }}
                              >
                              <i className="bi bi-book"></i>
                              </p> */}

                                                        {/* Toggle Button - FIXED */}
                                                        <button
                                                            className="btn ms-auto me-4 white"
                                                            onClick={() =>
                                                                setIsExpanded1(isExpanded1 === 1 ? 0 : 1)
                                                            }
                                                            style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                                        >
                                                            {isExpanded1 === 1 ? "−" : "+"}
                                                        </button>
                                                    </div>

                                                    {isExpanded1 === 1 && (
                                                        <div className="betting-options d-flex flex-column  gap-2">
                                                            <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                                                <h5 className="fs-3 text-wrap run">
                                                                    {runner1}
                                                                    <span
                                                                        className={`${matchLiabilities?.mini_bookmaker?.[runner1]
                                                                            ?.net < 0
                                                                            ? "text-red"
                                                                            : "text-green"
                                                                            }`}
                                                                    >
                                                                        {
                                                                            matchLiabilities?.mini_bookmaker?.[runner1]
                                                                                ?.net
                                                                        }
                                                                    </span>
                                                                </h5>

                                                                {mini1?.gstatus === "ACTIVE" ? (
                                                                    <div className="d-flex gap-2">
                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>
                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>

                                                                        <div
                                                                            className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                                                            style={{ width: "4rem" }}
                                                                        >
                                                                            {oddm1[2]?.odds}
                                                                        </div>

                                                                        <div
                                                                            className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                                                            style={{
                                                                                width: "4rem",
                                                                                backgroundColor: "#E83E8C",
                                                                            }}
                                                                        >
                                                                            {oddm1[3]?.odds}
                                                                        </div>

                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>
                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                                                        {mini1?.gstatus}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2">
                                                                <h5 className="fs-3 text-wrap run">
                                                                    {runner2}
                                                                    <span
                                                                        className={`${matchLiabilities?.mini_bookmaker?.[runner2]
                                                                            ?.net < 0
                                                                            ? "text-red"
                                                                            : "text-green"
                                                                            }`}
                                                                    >
                                                                        {
                                                                            matchLiabilities?.mini_bookmaker?.[runner2]
                                                                                ?.net
                                                                        }
                                                                    </span>
                                                                </h5>

                                                                {mini2?.status === "ACTIVE" ? (
                                                                    <div className="d-flex gap-2">
                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>
                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>

                                                                        <div
                                                                            className="bg-info rounded p-2 text-center fs-5 cursor-pointer"
                                                                            style={{ width: "4rem" }}
                                                                        >
                                                                            {oddm2[2]?.odds}
                                                                        </div>

                                                                        <div
                                                                            className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer"
                                                                            style={{
                                                                                width: "4rem",
                                                                                backgroundColor: "#E83E8C",
                                                                            }}
                                                                        >
                                                                            {oddm2[3]?.odds}
                                                                        </div>

                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>
                                                                        <div
                                                                            className="bg-secondary rounded p-2 dnone"
                                                                            style={{ width: "4rem" }}
                                                                        ></div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="bg-info-pink rounded fs-5 d-flex justify-content-center align-items-center media">
                                                                        {mini2?.gstatus}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                        {/* fancy market */}
                                        <div className="match-header d-flex flex-column align-items-start gap-2 mt-4 w-100 mb-5">
                                            <div className="d-flex align-items-baseline w-100">
                                                <p className="bg-yellow text-black pt-3 pb-2 me-5 px-2 rad bett">
                                                    Fancy Markets
                                                </p>

                                                <div
                                                    className="d-flex align-items-end gap-5 ms-0 ms-md-auto me-4 mt-2 mt-md-0 pr-3"
                                                    style={{ height: "5rem" }}
                                                >
                                                    <p className="text-pink fs-5">No</p>
                                                    <p className="text-info fs-5">Yes</p>
                                                </div>
                                            </div>

                                            <div className="bg-dark rounded gap-2 d-flex px-3 py-2 d-flex align-items-baseline w-100 pt-2 overflow-auto">
                                                <div
                                                    className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${newactive === 0 ? "colr" : ""
                                                        }`}
                                                    onClick={() => setNewActive(0)}
                                                >
                                                    ALL
                                                </div>
                                                <div
                                                    className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${newactive === 1 ? "colr" : ""
                                                        }`}
                                                    onClick={() => setNewActive(1)}
                                                >
                                                    SESSION
                                                </div>
                                                <div
                                                    className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet text-nowrap ${newactive === 2 ? "colr" : ""
                                                        }`}
                                                    onClick={() => setNewActive(2)}
                                                >
                                                    W/P MARKET
                                                </div>
                                                <div
                                                    className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${newactive === 3 ? "colr" : ""
                                                        }`}
                                                    onClick={() => setNewActive(3)}
                                                >
                                                    ODD/EVEN
                                                </div>
                                                <div
                                                    className={`border border-secondary rounded text-center px-4 py-1 border-warning cursor-pointer bet ${newactive === 4 ? "colr" : ""
                                                        }`}
                                                    onClick={() => setNewActive(4)}
                                                >
                                                    XTRA
                                                </div>
                                            </div>

                                            {/* session */}
                                            {Array.isArray(session) &&
                                                session.length > 0 &&
                                                (newactive === 0 || newactive === 1) ? (
                                                <div className="d-flex flex-column align-items-baseline w-100">
                                                    {/* Add your heading here */}

                                                    <div className="d-flex  flex-row gappp">
                                                        <p className="bg-yellow text-black pt-3 pb-3 px-2 rad bett">
                                                            Session
                                                        </p>
                                                        <button
                                                            className="btn ms-auto me-4 white"
                                                            onClick={() =>
                                                                setIsExpanded3(isExpanded3 === 1 ? 0 : 1)
                                                            }
                                                            style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                                        >
                                                            {isExpanded3 === 1 ? "−" : "+"}
                                                        </button>
                                                    </div>

                                                    {isExpanded3 === 1 && (
                                                        <div className="w-100">
                                                            {session?.map((item, index) => {

                                                                const fancyName = item?.rate?.fancyName;
                                                                const nat = item?.nat || "-";
                                                                const odds1 = item?.odds1?.odds || "-";
                                                                const odds2 = item?.odds2?.odds || "-";
                                                                const size1 = item?.odds1?.size || "-";
                                                                const size2 = item?.odds2?.size || "-";
                                                                // Find matching fancy bet data by runnerName
                                                                const matchingBet = fancyBetData.find(
                                                                    (fb) => fb.runnerName === fancyName
                                                                );

                                                                const betAmount = matchingBet?.betAmount || '';
                                                                const overallPosition = calculateOverallPosition(fancyName, fancyBetData);

                                                                return (
                                                                    <div key={index} className="w-100">
                                                                        <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100  mb-2">
                                                                            <h5 className="mb-3 mb-md-0 text-wrap run">
                                                                                {nat}
                                                                            </h5>

                                                                            <div className="d-flex gap-2">
                                                                                <div className="d-flex flex-column">
                                                                                    <span className="text-red fw-bold">
                                                                                        {overallPosition.loss < 0 ? overallPosition.loss : ''}
                                                                                    </span>
                                                                                    <span className="text-green fw-bold">
                                                                                        {overallPosition.profit > 0 ? overallPosition.profit : ''}
                                                                                    </span>
                                                                                </div>
                                                                                <img
                                                                                    className="small-grid ng-star-inserted mt-4 heig cursor-pointer"
                                                                                    src="/assets/images/ladder.svg"
                                                                                    alt="TVKheloyaar360"
                                                                                    onClick={() => {
                                                                                        setModalData(matchingBet); // pass your matchingData
                                                                                        setModal(true);
                                                                                        setFancyName(item?.rate?.fancyName)
                                                                                    }}
                                                                                />

                                                                                {item?.status === "OPEN" ? (
                                                                                    <>
                                                                                        <div
                                                                                            className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}
                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds2}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size2}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div
                                                                                            className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}
                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds1}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size1}
                                                                                            </span>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                                                        {item?.status || "CLOSED"}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <p className="text-white"></p>
                                            )}

                                            {/* wpmakrket */}
                                            {Array.isArray(wpMarket) &&
                                                wpMarket.length > 0 &&
                                                (newactive === 0 || newactive === 2) ? (
                                                <div className="d-flex flex-column align-items-baseline w-100">
                                                    {/* Add your heading here */}
                                                    <div className="d-flex  flex-row gappp">
                                                        <p className="bg-yellow text-black pt-3 pb-3 px-3 rad bett">
                                                            WP Market
                                                        </p>
                                                        <button
                                                            className="btn ms-auto me-4 white"
                                                            onClick={() =>
                                                                setIsExpanded4(isExpanded4 === 1 ? 0 : 1)
                                                            }
                                                            style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                                        >
                                                            {isExpanded4 === 1 ? "−" : "+"}
                                                        </button>
                                                    </div>
                                                    {isExpanded4 === 1 && (
                                                        <div className="w-100">
                                                            {/* Map through wpMarket */}
                                                            {wpMarket?.map((item, index) => {
                                                                const nat = item?.nat || "-";
                                                                const odds1 = item?.odds1?.odds || "-";
                                                                const odds2 = item?.odds2?.odds || "-";
                                                                const size1 = item?.odds1?.size || "-";
                                                                const size2 = item?.odds2?.size || "-";
                                                                const fancyName = item?.rate?.fancyName;
                                                                // Find matching fancy bet data by runnerName
                                                                const matchingBet = fancyBetData.find(
                                                                    (fb) => fb.runnerName === fancyName
                                                                );

                                                                const betAmount = matchingBet?.betAmount || '';
                                                                const overallPosition = calculateOverallPosition(fancyName, fancyBetData);

                                                                return (
                                                                    <div key={index} className="w-100 mb-2">
                                                                        <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100 mb-2">
                                                                            <h5 className="mb-3 mb-md-0 text-wrap run">
                                                                                {nat}
                                                                            </h5>

                                                                            <div className="d-flex gap-2">
                                                                                <div className="d-flex flex-column">
                                                                                    <span className="text-red fw-bold">
                                                                                        {overallPosition.loss < 0 ? overallPosition.loss : ''}
                                                                                    </span>
                                                                                    <span className="text-green fw-bold">
                                                                                        {overallPosition.profit > 0 ? overallPosition.profit : ''}
                                                                                    </span>
                                                                                </div>
                                                                                <img
                                                                                    className="small-grid ng-star-inserted mt-4 heig cursor-pointer"
                                                                                    src="/assets/images/ladder.svg"
                                                                                    alt="TVKheloyaar360"
                                                                                    onClick={() => {
                                                                                        setModalData(matchingBet); // pass your matchingData
                                                                                        setModal(true);
                                                                                        setFancyName(item?.rate?.fancyName)
                                                                                    }}
                                                                                />

                                                                                {item?.status === "OPEN" ? (
                                                                                    <>
                                                                                        <div
                                                                                            className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}

                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds2}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size2}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div
                                                                                            className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}

                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds1}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size1}
                                                                                            </span>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                                                        {item?.status}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <p className="text-white"></p>
                                            )}

                                            {/* odd even */}
                                            {Array.isArray(oddEven) &&
                                                oddEven.length > 0 &&
                                                (newactive === 0 || newactive === 3) ? (
                                                <div className="d-flex flex-column align-items-baseline w-100 mt-0">
                                                    {/* Add your heading here */}
                                                    <div className="d-flex  flex-row gappp">
                                                        <p className="bg-yellow text-black pt-3 pb-3 px-3 rad bett">
                                                            ODD/EVEN
                                                        </p>
                                                        <button
                                                            className="btn ms-auto me-4 white"
                                                            onClick={() =>
                                                                setIsExpanded6(isExpanded6 === 1 ? 0 : 1)
                                                            }
                                                            style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                                        >
                                                            {isExpanded6 === 1 ? "−" : "+"}
                                                        </button>
                                                    </div>
                                                    {isExpanded6 === 1 && (
                                                        <div className="w-100">
                                                            {/* Map through wpMarket */}
                                                            {oddEven?.map((item, index) => {
                                                                const nat = item?.nat || "-";
                                                                const odds1 = item?.odds1?.odds || "-";
                                                                const odds2 = item?.odds2?.odds || "-";
                                                                const size1 = item?.odds1?.size || "-";
                                                                const size2 = item?.odds2?.size || "-";
                                                                const fancyName = item?.rate?.fancyName;

                                                                const matchingBet = fancyBetData.find(
                                                                    (fb) => fb.runnerName === fancyName
                                                                );

                                                                const betAmount = matchingBet?.betAmount || '';
                                                                const overallPosition = calculateOverallPosition(fancyName, fancyBetData);

                                                                return (
                                                                    <div key={index} className="w-100">
                                                                        <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100 mb-2">
                                                                            <h5 className="mb-3 mb-md-0 text-wrap run">
                                                                                {nat}
                                                                            </h5>

                                                                            <div className="d-flex gap-2">
                                                                                <div className="d-flex flex-column">
                                                                                    <span className="text-red fw-bold">
                                                                                        {overallPosition.loss < 0 ? overallPosition.loss : ''}
                                                                                    </span>
                                                                                    <span className="text-green fw-bold">
                                                                                        {overallPosition.profit > 0 ? overallPosition.profit : ''}
                                                                                    </span>
                                                                                </div>
                                                                                <img
                                                                                    className="small-grid ng-star-inserted mt-4 heig cursor-pointer"
                                                                                    src="/assets/images/ladder.svg"
                                                                                    alt="TVKheloyaar360"
                                                                                    onClick={() => {
                                                                                        setModalData(matchingBet); // pass your matchingData
                                                                                        setModal(true);
                                                                                        setFancyName(item?.rate?.fancyName)
                                                                                    }}
                                                                                />

                                                                                {item?.status === "OPEN" ? (
                                                                                    <>
                                                                                        <div
                                                                                            className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}

                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds2}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size2}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div
                                                                                            className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}

                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds1}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size1}
                                                                                            </span>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                                                        {item?.status}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <p className="text-white"></p>
                                            )}

                                            {/* xtra */}
                                            {Array.isArray(fancy) &&
                                                fancy.length > 0 &&
                                                (newactive === 0 || newactive === 4) ? (
                                                <div className="d-flex flex-column align-items-baseline w-100">
                                                    {/* Add your heading here */}
                                                    <div className="d-flex  flex-row gappp">
                                                        <p className="bg-yellow text-black pt-3 pb-3 px-3 rad bett">
                                                            XTRA
                                                        </p>
                                                        <button
                                                            className="btn ms-auto me-4 white"
                                                            onClick={() =>
                                                                setIsExpanded5(isExpanded5 === 1 ? 0 : 1)
                                                            }
                                                            style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                                        >
                                                            {isExpanded5 === 1 ? "−" : "+"}
                                                        </button>
                                                    </div>

                                                    {isExpanded5 === 1 && (
                                                        <div className="w-100">
                                                            {/* Map through wpMarket */}
                                                            {fancy?.map((item, index) => {
                                                                const nat = item?.nat || "-";
                                                                const odds1 = item?.odds1?.odds || "-";
                                                                const odds2 = item?.odds2?.odds || "-";
                                                                const size1 = item?.odds1?.size || "-";
                                                                const size2 = item?.odds2?.size || "-";
                                                                const fancyName = item?.rate?.fancyName;

                                                                // Find matching fancy bet data by runnerName
                                                                const matchingBet = fancyBetData.find(
                                                                    (fb) => fb.runnerName === fancyName
                                                                );

                                                                const betAmount = matchingBet?.betAmount || '';
                                                                const overallPosition = calculateOverallPosition(fancyName, fancyBetData);

                                                                return (
                                                                    <div key={index} className="w-100">
                                                                        <div className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center border-2 bg-dark p-2 w-100 mb-2">
                                                                            <h5 className="mb-3 mb-md-0 text-wrap run">
                                                                                {nat}
                                                                            </h5>

                                                                            <div className="d-flex gap-2">
                                                                                <div className="d-flex flex-column">
                                                                                    <span className="text-red fw-bold">
                                                                                        {overallPosition.loss < 0 ? overallPosition.loss : ''}
                                                                                    </span>
                                                                                    <span className="text-green fw-bold">
                                                                                        {overallPosition.profit > 0 ? overallPosition.profit : ''}
                                                                                    </span>
                                                                                </div>
                                                                                <img
                                                                                    className="small-grid ng-star-inserted mt-4 heig cursor-pointer"
                                                                                    src="/assets/images/ladder.svg"
                                                                                    alt="TVKheloyaar360"
                                                                                    onClick={() => {
                                                                                        setModalData(matchingBet); // pass your matchingData
                                                                                        setModal(true);
                                                                                        setFancyName(item?.rate?.fancyName)
                                                                                    }}
                                                                                />

                                                                                {item?.status === "OPEN" ? (
                                                                                    <>
                                                                                        <div
                                                                                            className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}

                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds2}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size2}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div
                                                                                            className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                                                            style={{ width: "70px" }}

                                                                                        >
                                                                                            <span className="fonts">
                                                                                                {odds1}
                                                                                            </span>
                                                                                            <span>
                                                                                                {size1}
                                                                                            </span>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                                                        {item?.status}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <p className="text-white"></p>
                                            )}


                                            {modal && (
                                                <div style={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100vw',
                                                    height: '100vh',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    zIndex: 1000
                                                }}>
                                                    <div style={{
                                                        backgroundColor: '#000',
                                                        padding: '20px',
                                                        borderRadius: '8px',
                                                        minWidth: '400px',
                                                        textAlign: 'center'
                                                    }}>
                                                        <div className="d-flex justify-content-between">
                                                            <h4 className="text-start">{fancyName}</h4>
                                                            <button
                                                                className="bg-danger border-0 rounded px-3 text-white fs-5"
                                                                onClick={() => setModal(false)}
                                                            >
                                                                &times;
                                                            </button>
                                                        </div>

                                                        <table className="table mt-3">
                                                            <thead>
                                                                <tr>
                                                                    <th>Runs</th>
                                                                    <th>Position</th>
                                                                </tr>
                                                            </thead>

                                                            {generateModalTableData(fancyName, fancyBetData).map((row, index) => (
                                                                <tr key={index}>
                                                                    <td className="fs-5">{row.rate}</td>
                                                                    <td className={`fs-5 ${row.position >= 0 ? 'text-green' : 'text-red'}`}>
                                                                        {row.position}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                            <tbody>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="bets-container d-flex flex-column betTv  gap-2    ">
                                    <div className="d-none d-lg-block position-relative pl-1 ">
                                        {" "}
                                        {/* Added position relative */}
                                        <div
                                            className=" p-2 cursor-pointer d-flex justify-content-between"
                                            style={{ background: "#212121" }}
                                            onClick={() => setPlay(!play)}
                                        >
                                            <div>
                                                <span>
                                                    {" "}
                                                    <i
                                                        className="bi bi-broadcast fs-16"
                                                        style={{ color: "#DC3545" }}
                                                    ></i>
                                                </span>
                                                <span> Watch Live Match</span>
                                            </div>
                                            <div>
                                                <button className="live-stream-button ng-star-inserted">
                                                    {" "}
                                                    Watch Live{" "}
                                                </button>
                                            </div>
                                        </div>
                                        {play && (
                                            <iframe
                                                title="Live TV"
                                                className="border w-100 h-75"
                                                src={`https://5por-tt1.top/directstreaming.php?chid=${channel}`}
                                                allowFullScreen
                                                referrerPolicy="strict-origin-when-cross-origin"
                                                sandbox="allow-same-origin allow-scripts"
                                            ></iframe>
                                        )}
                                    </div>

                                    <div
                                        className="table-responsive rounded-4 mt-3 mt-lg-0 ms-0 ms-lg-1 mb-4  h-100"
                                        style={{
                                            maxHeight: "100vh",
                                            height: `${betData.length * 6}vh`,
                                        }}
                                    >
                                        <div
                                            className="m-0 rounded-top-3 p-2 bett"
                                            style={{
                                                background:
                                                    "linear-gradient(to right, #f2d71a, #ecb024)",
                                                color: "#000",
                                            }}
                                        >
                                            My Bets
                                        </div>

                                        <table
                                            className="border w-100"
                                            style={{ borderCollapse: "collapse" }}
                                        >
                                            <thead>
                                                <div
                                                    style={{
                                                        color: "black",
                                                        fontFamily: "sans-serif",
                                                    }}
                                                    className="pl-1"
                                                >
                                                    Unmatched bets
                                                </div>
                                                <tr className="text-dark">
                                                    <th>Runner Name</th>
                                                    <th>ODDS</th>
                                                    <th>Bet Amount</th>
                                                    <th>P/L</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {unmatch?.length > 0 ? (
                                                    unmatch?.map((bet, index) => (
                                                        <tr key={index} className="text-dark"
                                                            style={{
                                                                background: bet.side === 'Lay'
                                                                    ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                                                                    : 'linear-gradient(180deg, #84c2f1, #d9efff)'
                                                            }}
                                                        >
                                                            <td>
                                                                {bet.runnerName}&nbsp;({bet.type})
                                                            </td>
                                                            <td>{bet.betprice}</td>
                                                            <td>{bet.betAmount}</td>
                                                            <td>{bet.side === "Back" ? bet.profit : bet.betAmount}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr></tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <table
                                            className="border  w-100"
                                            style={{ borderCollapse: "collapse" }}
                                        >
                                            <thead>
                                                <div
                                                    style={{
                                                        color: "Black",
                                                        fontFamily: "sans-serif",
                                                    }}
                                                    className="pl-1"
                                                >
                                                    Matched bets
                                                </div>
                                                <tr className="text-dark">
                                                    <th>Phone</th>

                                                    <th>Runner Name</th>
                                                    <th>ODDS</th>
                                                    <th>Bet Amount</th>
                                                    <th>P/L</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {/* Sports Bets */}
                                                {betData?.length > 0 ? (
                                                    <>
                                                        <tr className="text-dark">
                                                            <th
                                                                colSpan={4}
                                                                style={{
                                                                    background: "#000",
                                                                    color: "#fff",
                                                                }}
                                                            >
                                                                Sports Bets
                                                            </th>
                                                        </tr>
                                                        {betData.map((bet, index) => (

                                                            <tr key={`sports-${index}`} className="text-dark"
                                                                style={{
                                                                    background: bet?.side === 'Lay'
                                                                        ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                                                                        : 'linear-gradient(180deg, #84c2f1, #d9efff)'
                                                                }}
                                                            >
                                                                <td>{bet.phone}</td>
                                                                <td>
                                                                    {bet.runnerName} ({bet.type})
                                                                </td>
                                                                <td>{bet.betprice}</td>
                                                                <td>{bet.betAmount}</td>
                                                                <td>{bet.side === "Back" ? bet.profit : bet.betAmount}</td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <tr className="text-dark">
                                                        <td
                                                            colSpan={4}
                                                            style={{ color: "gray", textAlign: "center" }}
                                                        >
                                                            No sports bet data
                                                        </td>
                                                    </tr>
                                                )}

                                                {/* Fancy Bets */}
                                                {fancyBetData?.length > 0 ? (
                                                    <>
                                                        <tr className="text-dark" >
                                                            <th
                                                                colSpan={4}
                                                                style={{
                                                                    background: "#000",
                                                                    color: "#fff",
                                                                }}
                                                            >
                                                                Fancy Bets
                                                            </th>
                                                        </tr>
                                                        {fancyBetData.map((bet, index) => (
                                                            <tr key={`fancy-${index}`} className="text-dark"
                                                                style={{
                                                                    background: bet.side === 'no'
                                                                        ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                                                                        : 'linear-gradient(180deg, #84c2f1, #d9efff)'
                                                                }}
                                                            >
                                                                <td>{bet.phone}</td>
                                                                <td>
                                                                    {bet.runnerName} ({bet.type})
                                                                </td>
                                                                <td>{bet.rate}</td>
                                                                <td>{bet.betAmount}</td>
                                                                <td>{bet.side === 'Back' ? bet.profit : bet.betAmount}</td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan={4}
                                                            style={{ color: "gray", textAlign: "center" }}
                                                        >
                                                            No fancy bet data
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomeCricket;